import React from 'react';
import { Sidebar as _Sidebar } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useSidebarStyles = makeStyles({
	/*
    drawerPaper: {
        width:127,
        closedWidth: 55,
    },
 	*/
});

const Sidebar = props => {
    const classes = useSidebarStyles();
    return (
        <_Sidebar classes={classes} {...props} />
    );
};

export default Sidebar;